/**
 * Mock Telegram WebApp for development and testing
 * Used when app is not running inside Telegram
 */
import {
  TG_BG_LIGHT, TG_TEXT_LIGHT, TG_HINT_LIGHT, ACTION_LIGHT, ON_ACTION_LIGHT,
} from '../constants/colors';

const mockUser = {
  id: 123456789,
  first_name: 'Test',
  last_name: 'User',
  username: 'testuser',
  language_code: 'ru',
  is_premium: false,
};

// Generate mock initData for development (not validated in dev mode)
const mockInitData = `user=${encodeURIComponent(JSON.stringify(mockUser))}&auth_date=${Math.floor(Date.now() / 1000)}&hash=mock_hash_for_development`;

const mockWebApp = {
  initData: mockInitData,
  initDataUnsafe: {
    user: mockUser,
    auth_date: Math.floor(Date.now() / 1000),
  },
  version: '6.0',
  platform: 'web',
  // Следуем системной теме, чтобы в dev-режиме проверять оба варианта
  colorScheme: (typeof window !== 'undefined' &&
    window.matchMedia?.('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light',
  themeParams: {
    bg_color: TG_BG_LIGHT,
    text_color: TG_TEXT_LIGHT,
    hint_color: TG_HINT_LIGHT,
    link_color: ACTION_LIGHT,
    button_color: ACTION_LIGHT,
    button_text_color: ON_ACTION_LIGHT,
  },
  isExpanded: false,
  viewportHeight: 800,
  viewportStableHeight: 800,
  headerColor: TG_BG_LIGHT,
  backgroundColor: TG_BG_LIGHT,
  isClosingConfirmationEnabled: false,
  safeAreaInset: { top: 0, bottom: 0, left: 0, right: 0 },
  contentSafeAreaInset: { top: 0, bottom: 0, left: 0, right: 0 },
  eventHandlers: {},
  BackButton: {
    isVisible: false,
    onClick: (callback) => {},
    offClick: (callback) => {},
    show: () => {},
    hide: () => {},
  },
  MainButton: {
    text: '',
    color: ACTION_LIGHT,
    textColor: ON_ACTION_LIGHT,
    isVisible: false,
    isActive: true,
    isProgressVisible: false,
    setText: (text) => {},
    onClick: (callback) => {},
    offClick: (callback) => {},
    show: () => {},
    hide: () => {},
    enable: () => {},
    disable: () => {},
    showProgress: () => {},
    hideProgress: () => {},
    setParams: (params) => {},
  },
  HapticFeedback: {
    impactOccurred: (style) => {},
    notificationOccurred: (type) => {},
    selectionChanged: () => {},
  },
  ready: () => {},
  expand: () => {},
  close: () => {},
  enableClosingConfirmation: () => {},
  disableClosingConfirmation: () => {},
  setHeaderColor: (color) => {},
  setBackgroundColor: (color) => {},
  openLink: (url) => {
    window.open(url, '_blank');
  },
  openTelegramLink: (url) => {},
  showPopup: (params, callback) => {
    if (callback) callback();
  },
  showAlert: (message, callback) => {
    alert(message);
    if (callback) callback();
  },
  showConfirm: (message, callback) => {
    // eslint-disable-next-line no-restricted-globals
    const result = confirm(message);
    if (callback) callback(result);
  },
  sendData: (data) => {},
  requestLocation: (callback) => {
    // Mock coordinates - fixed test location
    const mockLocation = {
      latitude: 59.933735,
      longitude: 30.341991,
    };

    // Simulate 1 second delay
    setTimeout(() => {
      if (callback) {
        callback(mockLocation);
      }
    }, 1000);
  },
  disableVerticalSwipes: () => {},
  web_app_request_safe_area: () => {},
  web_app_request_content_safe_area: () => {},
  onEvent: (eventType, callback) => {
    if (!mockWebApp.eventHandlers[eventType]) {
      mockWebApp.eventHandlers[eventType] = [];
    }
    mockWebApp.eventHandlers[eventType].push(callback);
  },
  offEvent: (eventType, callback) => {
    if (mockWebApp.eventHandlers[eventType]) {
      mockWebApp.eventHandlers[eventType] = mockWebApp.eventHandlers[eventType].filter(
        (cb) => cb !== callback
      );
    }
  },
};

export const getMockTelegramWebApp = () => {
  return mockWebApp;
};

export const getMockUser = () => mockUser;

export default mockWebApp;
